export const ZOK_NO_PAYMENT_METHOD = "zok-no-payment-method";
export const ZOK_PRICE_LIST_EXISTS = "zok-price-list-exists";
export const ZOK_TIER_EXISTS = 'zok-tier-exists';
export const ZOK_TIER_IN_USE = "zok-tier-in-use";
export const ZOK_SERVICE_UNAVAILABLE = "zok-service-unavailable";